import { getCurrentInstance, useSSRContext } from "vue";
import { getMultiCacheRouteHelper } from "./../helpers/server.js";
export function useRouteCache(cb, providedEvent) {
  const isServer = import.meta.env.VITEST_SERVER === "true" || import.meta.server;
  if (!isServer) {
    return;
  }
  const event = (() => {
    if (providedEvent) {
      return providedEvent;
    }
    if (!getCurrentInstance()) {
      return;
    }
    const ssrContext = useSSRContext();
    if (ssrContext) {
      return ssrContext.event;
    }
  })();
  if (!event) {
    return;
  }
  const helper = getMultiCacheRouteHelper(event);
  if (!helper) {
    return;
  }
  cb(helper);
}
